import React from "react"; 

// Components
import SectionTitle from "../SectionTitle";

const SetUpStatus = ( {setupSteps} ) => {

    return(
        <>
            <div className="flex items-center justify-between mb-5 pr-6 border-b border-ec-table-stock">
                <SectionTitle title="Setup Status" />
            </div>

            <p className="text-sm text-ec-black mb-3 px-[30px]">You're almost ready to start selling! Just complete the steps below to fully set up your store and unlock all features.</p>
            
            <ul className="list-inside space-y-2 text-ec-title font-inter text-base font-normal px-[30px] pb-[30px]">
                {setupSteps.map((step, index) => (
                    <li key={index} className="flex items-center gap-2">
                        <span>
                            {step.status ? (
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="20" height="20" rx="10" fill="#00975A"/>
                                    <path d="M14.1499 6.66701C13.984 6.67227 13.8267 6.74199 13.7113 6.86135C12.1284 8.44774 10.434 10.2655 8.85246 11.8697L6.59495 10.0109C6.53177 9.94899 6.45641 9.9009 6.37365 9.86967C6.2909 9.83845 6.20255 9.82478 6.11423 9.82952C6.0259 9.83427 5.93953 9.85733 5.86059 9.89724C5.78166 9.93715 5.71188 9.99303 5.6557 10.0613C5.59952 10.1297 5.55816 10.2089 5.53425 10.2941C5.51034 10.3792 5.5044 10.4684 5.5168 10.556C5.52921 10.6436 5.55969 10.7276 5.60631 10.8028C5.65294 10.878 5.71468 10.9426 5.78762 10.9927L8.49863 13.2252C8.62088 13.3264 8.77643 13.3783 8.93491 13.371C9.0934 13.3636 9.24345 13.2974 9.35579 13.1854C11.0699 11.4676 12.9304 9.45499 14.6183 7.76337C14.7113 7.67357 14.7748 7.55762 14.8005 7.43091C14.8261 7.30419 14.8126 7.17268 14.7618 7.0538C14.711 6.93491 14.6253 6.83427 14.516 6.7652C14.4068 6.69612 14.2791 6.66188 14.1499 6.66701Z" fill="white"/>
                                </svg>
                            ) : (
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="20" height="20" rx="10" fill="#BCBCC3"/>
                                    <path d="M13.6394 7.0005C13.4735 7.00577 13.3162 7.07548 13.2008 7.19485C11.6179 8.78123 9.92347 10.599 8.34196 12.2032L6.08445 10.3444C6.02127 10.2825 5.94591 10.2344 5.86316 10.2032C5.7804 10.1719 5.69205 10.1583 5.60373 10.163C5.5154 10.1678 5.42903 10.1908 5.3501 10.2307C5.27116 10.2706 5.20139 10.3265 5.14521 10.3948C5.08903 10.4632 5.04767 10.5424 5.02375 10.6276C4.99984 10.7127 4.9939 10.8019 5.00631 10.8895C5.01871 10.9771 5.04919 11.0611 5.09582 11.1363C5.14244 11.2115 5.20418 11.2761 5.27713 11.3262L7.98813 13.5587C8.11038 13.6599 8.26593 13.7118 8.42441 13.7045C8.5829 13.6971 8.73295 13.6309 8.84529 13.5189C10.5594 11.8011 12.4199 9.78848 14.1078 8.09686C14.2008 8.00706 14.2643 7.89112 14.29 7.7644C14.3156 7.63769 14.3021 7.50618 14.2513 7.3873C14.2005 7.26841 14.1148 7.16777 14.0055 7.09869C13.8963 7.02962 13.7686 6.99537 13.6394 7.0005Z" fill="white"/>
                                </svg>
                            )}
                        </span>
                        <span>
                            {step.status ? (
                                <span className="text-ec-title">{step.label}</span>
                                ) : (
                                <a href={step.link || '#'} className="text-[#175AEA] underline decoration-solid">
                                    {step.label}
                                </a>
                            )}
                        </span>
                    </li>
                ))}
            </ul>
        </>
    );
};

export default SetUpStatus;
